// extracted by mini-css-extract-plugin
export default {"datepicker":"components-settings-budget-forecast-datepicker-module__datepicker"};